var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"books",class:[("grid-column-" + _vm.columnCount)]},_vm._l((_vm.listData),function(book){return _c('book-card',{key:book.id,attrs:{"book-data":book}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }